(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !window.DesignMode) return;
  try {
    
const elements = document.querySelectorAll('.mg-accordion');
window.console.log("test",elements);
elements.forEach(element => {
  let btn = element.querySelector('.mg-accordion-header');

  btn.addEventListener('click', ()=>{
  	element.classList.toggle('active');
	window.console.log("click",element);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-new"]) return;
  try {
    
(function() {
  const popupbtn = document.querySelector('button.openpopup');
  const popupele = document.querySelector('#CountryPopUp');
  const popupclose = document.querySelector('#CountryPopUp .close');
  const popupclosebtn = document.querySelector('#CountryPopUp .continuebtn');
if(typeof(popupbtn) != 'undefined' && popupbtn != null){
  popupbtn.addEventListener('click', ()=>{
  	popupele.classList.toggle('popup-hide');
  });
  popupclose.addEventListener('click', ()=>{
  	popupele.classList.toggle('popup-hide');
  });
if(typeof(popupclosebtn) != 'undefined' && popupclosebtn != null){
  popupclosebtn.addEventListener('click', ()=>{
  	popupele.classList.toggle('popup-hide');
  });
}
  }
})();
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button.disclosure__button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  	const toggleButtons = document.querySelectorAll('.site_header .j-search-toggle');
	const searchInputField = document.querySelector('#search-input-field');
	const modal = document.querySelector('.site_header .search_modal');

	if (modal && toggleButtons.length > 0) {
	  toggleButtons.forEach(function (btn) {
	    btn.addEventListener('click', function () {
	      modal.classList.toggle('active');

	      // Only focus the input if modal is now active
	      if (modal.classList.contains('active') && searchInputField) {
	        searchInputField.focus();
	      }
	    });
	  });
	}


  const menuToggle = document.querySelector('.mobile-menu-toggle');

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      document.body.classList.toggle('menu-active');
    });
  }

  // const links = document.querySelectorAll('.primary-link.has-children');

  // links.forEach(function (link) {
  //   link.addEventListener('click', function (e) {
  //     e.preventDefault(); // Optional: prevent default if it's an anchor
  //     this.parentElement.classList.toggle('expand');
  //   });
  // });

  	document.addEventListener('DOMContentLoaded', function() {

    	$(function(){

    		$('.j-show-lifestyle-image').hover(function(e) {
				var image = $(this).data('image');
				$('.megamenu .img.initial').addClass('hide');
				$('.megamenu .collection-img').removeClass('active');
				$('.megamenu .collection-img[data-image="'+image+'"]').addClass('active');
			},
			function(){
				$('.megamenu .collection-img').removeClass('active');
				setTimeout(function(){
					$('.megamenu .img.initial').removeClass('hide');
				}, 1000);
			});

			$('.primary-link.has-children').on('click', function(e) {
				if ($(window).width() < 990) {
			  		e.preventDefault(); // Optional: prevent default if it's an anchor
			  	}
			  	$(this).parent().toggleClass('expand');
			});


			if ($(window).width() < 990) {

				// Click to show child nav
				$(document).on('click', '.megamenu nav a.has-children', function(e){

					e.preventDefault();
					$(this).parent().toggleClass('expand');

				});

			} else {

				// Hover to show child nav
				$(document).on('mouseenter', '.megamenu nav a.has-children', function(){

					$('.megamenu nav li').removeClass('expand');
					$(this).parent().addClass('expand');

				});

				$(document).on('mouseenter', '.megamenu nav a.secondary-link:not(.has-children)', function(){
					$('.megamenu nav li').removeClass('expand');
				});

				$(document).on('mouseleave', '.megamenu nav', function(){
					$('.megamenu nav li').removeClass('expand');
				});
			}

    	});

    }, false);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  const popupbtn = document.querySelector('button.openpopup');
  const popupele = document.querySelector('#CountryPopUp');
  const popupclose = document.querySelector('#CountryPopUp .close');
  const popupclosebtn = document.querySelector('#CountryPopUp .continuebtn');
if(typeof(popupbtn) != 'undefined' && popupbtn != null){
  popupbtn.addEventListener('click', ()=>{
  	popupele.classList.toggle('popup-hide');
  });
  popupclose.addEventListener('click', ()=>{
  	popupele.classList.toggle('popup-hide');
  });
if(typeof(popupclosebtn) != 'undefined' && popupclosebtn != null){
  popupclosebtn.addEventListener('click', ()=>{
  	popupele.classList.toggle('popup-hide');
  });
}
  }
})();
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button.disclosure__button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
